export default {
  getHead: () => {
    return [{name: '현장명'}, {name: '협의일'}, {name: '회의장소'}, {name: '노측 위원(명)'}, {name: '사측 위원(명)'}, {name: '재해형태'},  {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 현장명
        case 1: return func.getContent(value).inputA_2 // 협의일
        case 2: return func.getContent(value).inputA_3 // 회의장소
        case 3: return func.getContent(value).inputA_4 // 노측위원(명)
        case 4: return func.getContent(value).inputA_5 // 사측위원(명)
        case 5: return func.getContent(value).inputB_3 // 재해형태
        case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.inputB_3*[:default_disaster]')

    switch (nav.value.searchType) {
      case '현장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '협의일': returnData.push('content$body.inputA_2*%[:default_skw]%'); break
      case '회의장소': returnData.push('content$body.inputA_3*%[:default_skw]%'); break
      case '노측위원(명)': returnData.push('content$body.inputA_4*%[:default_skw]%'); break
      case '사측위원(명)': returnData.push('content$body.inputA_5*%[:default_skw]%'); break
      case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
      case '부서명': returnData.push('content$body.stdInfo.com_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
